import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  props: ['editedPeriod'],
  data () {
    return {
      loading: false,
      updatedPeriod: ''
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  methods: {
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    async updatePeriod () {
      this.loading = true
      this.updatedPeriod.updateUser = this.$store.state.user.user.login
      this.$store.dispatch('periode/updatePeriode', this.updatedPeriod).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/periode/view', params: { 'editedPeriod': this.updatedPeriod } })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    }
  },
  mounted () {
    if (this.editedPeriod) {
      this.$store.dispatch('user/selectPeriode', this.editedPeriod)
      this.updatedPeriod = JSON.parse(JSON.stringify(this.editedPeriod))
    } else {
      this.$router.push({ name: 'administration/periode/list' })
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Modification d\'une période'
    this.$store.state.filArianeMiddlePage = 'Liste des périodes'
    this.$store.state.filArianeMiddleRouterLink = 'administration/periode/list'
  }
}
